/* eslint-disable react/prop-types */

import React, { useState, useRef, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Select, { components } from 'react-select';
import { Form, Col } from 'react-bootstrap';
import { FormLabel } from './FormLabel';
import ErrorFeedback from './ErrorFeedback';

const CalculationField = ({ metadata, formValues }) => {
  const {
    watch,
    setValue,
    register,
    formState: { errors }
  } = useFormContext();
  // Watch all dependent fields
  const dependentValues = watch(metadata.dependsOn);
  const currentValue = watch(metadata.id);
  const { quantity, unit_price } = formValues;
  useEffect(() => {
    // Skip calculation if dependent values aren't ready
    if (
      !dependentValues ||
      !dependentValues.every(val => val !== undefined && val !== '')
    ) {
      if (currentValue !== null) {
        setValue(metadata.id, null, {
          shouldDirty: true,
          shouldValidate: true
        });
      }
      return;
    }

    try {
      // Calculate the result
      const results = eval(metadata?.calculation);
      // Only update if the result has changed
      if (results !== currentValue) {
        setValue(metadata.id, results, {
          shouldDirty: true,
          shouldValidate: true
        });
      }
    } catch (error) {
      console.error('Calculation error:', error);
      setValue(metadata.id, null);
    }
  }, [dependentValues, metadata.id, metadata.calculation, setValue]);

  return (
    <Col>
      <Form.Group as={Col} sm={12} md={12} className="mb-3">
        <FormLabel
          label={metadata.label}
          required={metadata?.validation?.required}
          htmlFor={metadata.id}
        />
        <Form.Control
          id={metadata.id}
          {...register(metadata.id)}
          type="number"
          placeholder={metadata.placeholder}
          isInvalid={!!errors[metadata.id]}
          disabled={!metadata.isEditable}
        />
        <ErrorFeedback error={errors[metadata.id]} />
      </Form.Group>
    </Col>
  );
};
export default CalculationField;
